import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button, Drawer } from "@/ui-kit";
import { Form } from "@/components/controls";
import { FormProvider } from "react-hook-form";
import {
  TaxInformationForm,
  useTaxInformationForm,
} from "@/components/profile-forms/TaxInformationForm";
import type { IInspectorW9Form } from "@/types/users-inspectors";

type IProps = {
  userId: number;
  w9form: IInspectorW9Form;
  onSave: (v: IInspectorW9Form) => void;
  onDismiss: () => void;
};

const EditModal = ({ userId, w9form, onSave, onDismiss }: IProps) => {
  const { t } = useTranslation();

  const handleSuccess = useCallback(
    (response: IInspectorW9Form) => {
      onSave(response);
      onDismiss();
    },
    [onSave, onDismiss],
  );

  const { form, onSubmit, loading, disabled, setDisabled } =
    useTaxInformationForm({
      userId,
      w9Form: w9form,
      onSuccess: handleSuccess,
    });

  return (
    <FormProvider {...form}>
      <Drawer
        className="settings__user-modal"
        title={t("label.tax_information")}
        open={true}
        onOpenChange={onDismiss}
        closeOnOutsidePress={false}
        footer={
          <>
            <Button onClick={onDismiss} variant="ghost" color="layer1">
              {t("action.cancel")}
            </Button>
            <Button onClick={onSubmit} loading={loading} disabled={disabled}>
              {t("action.save")}
            </Button>
          </>
        }
      >
        <Form>
          <TaxInformationForm color="layer1" setDisabled={setDisabled} />
        </Form>
      </Drawer>
    </FormProvider>
  );
};

export default EditModal;
